import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { User } from "./user";
import jwt_decode from 'jwt-decode';
import { Router } from "@angular/router";
import { TokenService } from "../token/token.service";
@Injectable({
  providedIn: 'root'
})
export class UserService {

  private readonly userSubject = new BehaviorSubject<User | null>(null);
  private readonly userLogged = new BehaviorSubject<boolean>(false);

  constructor(private readonly tokenService: TokenService,
    private readonly router: Router) {

    if (this.tokenService.hasToken())
      this.decodeAndNotify();
  }

  setToken(token: string, refreshToken: string) {

    this.tokenService.setToken(token, refreshToken);
    this.decodeAndNotify();

  }

  getUser() {

    return this.userSubject.asObservable();

  }

  private decodeAndNotify() {

    const token: string = this.tokenService.getToken();
    const user = jwt_decode<User>(token);
    this.userSubject.next(user);
    this.userLogged.next(true);

  }

  logout() {

    this.tokenService.removeToken();
    this.userSubject.next(null);
    this.userLogged.next(false);
    this.router.navigate(['']);

  }

  isLogged() {
    return this.tokenService.hasToken();
  }

  get isLoggedIn() {
    return this.userLogged.asObservable();
  }

}
